import { rotate } from "components/Loader/Loader.styled";
import SingleSelect from "components/SingleSelect";
import Text from "components/Text";
import TextInput from "components/TextInput";
import styled from "styled-components";
import theme from "theme";

export const PageContent = styled.main`
    width: 100%;
    grid-area: main;

    @media (${theme.breakpoints.mobileL}) {
        overflow: hidden;
    }

    .loader {
        animation: ${rotate} 2s linear infinite;
        color: ${theme.colors.purple.primary};
    }
`;

export const EditProfileInnerWrapper = styled.div`
    padding: 24px;
    background: #f9f9f9;
    display: flex;
`;

export const ProgressCard = styled.div<{ marginTop?: string }>`
    border-radius: 14px;
    bottom: 24px;
    left: 24px;
    width: 100%;
    padding: 24px;
    border: 1px solid #efefef;
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-top: ${({ marginTop }) => marginTop || "20px"};

    @media (${theme.breakpoints.mobileL}) {
        display: none;
    }
`;

export const ProfileContentWrapper = styled.div`
    margin: 0 14px;
    background-color: #fff;
    padding: 20px 28px;
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    position: relative;
    height: 100%;
    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.05);

    @media (${theme.breakpoints.mobileL}) {
        padding: 14px;
    }

    @media (${theme.breakpoints.mobileM}) {
        ${TextInput.Style} {
            width: 100%;
        }

        ${SingleSelect.Style} {
            width: 100%;
        }
    }
`;

export const SubHeading = styled(Text)`
    margin-top: 30px;
    color: ${theme.colors.grey.secondary};
    display: flex;
    align-items: center;

    @media (${theme.breakpoints.mobileL}) {
        font-size: 11px;
    }
`;

export const StraightLine = styled.div`
    height: 0px;
    border-bottom: 1px solid ${theme.colors.grey.secondary};
    width: 232px;
    margin-left: 10px;
`;
